/**
 * OAuth popups are opened inside the click, before their URL is known, so they
 * start as about:blank. Fill one with a short status so the seller never faces
 * a blank window — and, where a browser will not let this page close it (store
 * and anti-detect browsers among them), an error stays readable there instead
 * of only in a toast hidden behind the popup.
 */
export interface PopupStatus {
  title: string;
  message: string;
  hint?: string;
}

export function showPopupStatus(popup: Window, status: PopupStatus): void {
  try {
    const doc = popup.document;
    if (!doc?.body) return;
    doc.title = status.title;
    doc.documentElement.style.colorScheme = "light dark";

    const main = doc.createElement("main");
    main.style.cssText =
      "font-family:system-ui,sans-serif;max-width:28rem;margin:20vh auto 0;padding:0 16px;text-align:center";
    const heading = doc.createElement("h1");
    heading.style.cssText = "font-size:18px;font-weight:600;margin:0 0 8px";
    heading.textContent = status.title;
    main.append(heading);
    for (const text of [status.message, status.hint]) {
      if (!text) continue;
      const line = doc.createElement("p");
      line.style.cssText = "font-size:14px;line-height:1.5;margin:0 0 4px;opacity:.75";
      line.textContent = text;
      main.append(line);
    }
    doc.body.replaceChildren(main);
  } catch {
    // The browser may deny access to the popup's document; the toast still reports the outcome.
  }
}
